import * as React from "react";
import styled from "styled-components";
import { media } from "../../common/utils/style";

import i18n from "../../lib/i18n";
import { Company, CompanyMembershipSection } from "../entities";
import Carousel from "../../common/components/Carousel";
import { SectionInner } from "./Section";
import { navFullPath } from "./HeaderNav";
import StartActionCard from "./StartActionCard";
import MembershipTeamCard from "./MembershipTeamCard";

interface Props {
  company: Company;
  membershipSections: CompanyMembershipSection[];
  editable?: boolean;
  locale: string;
}

class MembershipTeamList extends React.Component<Props> {
  public render() {
    const { company, membershipSections, editable, locale } = this.props;
    const hasContent = membershipSections.length > 0;

    if (!editable && !hasContent) {
      return null;
    }
    return (
      <Wrapper>
        {editable &&
          !hasContent && (
            <StartActionCard
              message={i18n.translate("company.home.start_members_card.message", { locale })}
              subMessage={i18n.translate("company.home.start_members_card.sub_message", { locale })}
              buttonText={i18n.translate("company.home.start_members_card.button_text", { locale })}
              linkPath={navFullPath(company, "/members")}
              inAppLink
            />
          )}
        {hasContent && (
          <CarouselWrapper>
            <Carousel
              layouts={{
                small: { perPage: 1.5, gutter: 16 },
                medium: { perPage: 3, gutter: 16 },
                large: { perPage: 4, gutter: 30 },
              }}
              childCount={membershipSections.length}
              renderChild={(index, isActive) => {
                const section = this.props.membershipSections[index];
                return (
                  <MembershipTeamCard key={section.id} section={section} company={company} floatsByHover={isActive} />
                );
              }}
            />
          </CarouselWrapper>
        )}
      </Wrapper>
    );
  }
}

const Wrapper = styled.section`
  margin-top: 60px;
  padding-top: 10px; /* Padding for translateY of hovered card */
  overflow: hidden;
  @media ${media.large} {
    margin: 60px auto 0;
    padding-top: 10px;
  }
`;

const CarouselWrapper = styled(SectionInner)`
  margin: 0 30px 0 16px;
  @media ${media.large} {
    margin: 0 auto;
  }
`;

export default MembershipTeamList;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/MembershipTeamList.tsx